import axios from 'axios';

export function requestInterceptor_Axios(onFulfilled, onRejected) {
	axios.interceptors.request.use(onFulfilled, onRejected);
}

export function responseInterceptor_Axios(onFulfilled, onRejected) {
	axios.interceptors.response.use(onFulfilled, onRejected);
}
